import React from 'react';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { Button } from '@mui/material';

const ConfirmationModal = ({ openConfirmationModal, setOpenConfirmationModal, handleConfirmation }) => {
  return (
    <Modal
      open={openConfirmationModal}
      onClose={() => setOpenConfirmationModal(false)}
      closeAfterTransition
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(5px)',
        },
      }}
    >
      <Fade in={openConfirmationModal}>
        <div
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
            maxWidth: '500px',
            width: '100%',
            position: 'relative', 
          }}
        >
          {/* Close Button */}
          <button
            type="button"
            className="close"
            onClick={() => setOpenConfirmationModal(false)}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
            }}
          >
            <span>&times;</span>
          </button>

          <div className="modal-header">
            <h5 className="modal-title">Confirm Action</h5>
          </div>
          <div className="modal-body">
            <p>Are you sure you want to send this measurement to the manufacturer and change the status to "Confirmed"?</p>
          </div>
          <div className="modal-footer" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => handleConfirmation(false)}
              sx={{
                width: '100%',
                '@media (min-width: 600px)': {
                  width: 'auto', 
                },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleConfirmation(true)}
              sx={{
                width: '100%',
                '@media (min-width: 600px)': {
                  width: 'auto', 
                },
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default ConfirmationModal;
